import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 10.5V5.5C22 5.36739 21.9473 5.24021 21.8535 5.14645C21.7598 5.05268 21.6326 5 21.5 5H16.5C16.3674 5 16.2402 5.05268 16.1464 5.14645C16.0527 5.24021 16 5.36739 16 5.5V5.79C15.999 5.85708 16.0118 5.92364 16.0376 5.98557C16.0634 6.04749 16.1017 6.10346 16.15 6.15L17.79 7.79L13.5 12.09L10.85 9.44C10.8051 9.39217 10.7509 9.35405 10.6907 9.32799C10.6305 9.30193 10.5656 9.28848 10.5 9.28848C10.4344 9.28848 10.3695 9.30193 10.3093 9.32799C10.2491 9.35405 10.1949 9.39217 10.15 9.44L2.14997 17.44C2.10311 17.4865 2.06591 17.5418 2.04053 17.6027C2.01514 17.6636 2.00208 17.729 2.00208 17.795C2.00208 17.861 2.01514 17.9264 2.04053 17.9873C2.06591 18.0482 2.10311 18.1035 2.14997 18.15L2.84997 18.85C2.89646 18.8969 2.95176 18.9341 3.01269 18.9594C3.07362 18.9848 3.13897 18.9979 3.20497 18.9979C3.27098 18.9979 3.33633 18.9848 3.39726 18.9594C3.45819 18.9341 3.51349 18.8969 3.55997 18.85L10.5 11.91L13.15 14.56C13.1949 14.6078 13.2491 14.646 13.3093 14.672C13.3695 14.6981 13.4344 14.7115 13.5 14.7115C13.5656 14.7115 13.6305 14.6981 13.6907 14.672C13.7509 14.646 13.8051 14.6078 13.85 14.56L19.21 9.21L20.85 10.85C20.8965 10.8983 20.9525 10.9366 21.0144 10.9624C21.0763 10.9882 21.1429 11.001 21.21 11H21.5C21.6326 11 21.7598 10.9473 21.8535 10.8536C21.9473 10.7598 22 10.6326 22 10.5Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgTrendingOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgTrendingOutline;
